import { browserHistory } from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/socialnetworks';

const XService = {

  getCode( code ) {
    return axios
      .get( `v1/public/tw/token?code=${code}` )
  },


};

export default XService;



// WEBPACK FOOTER //
// ./services/XService.js